import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../../components/shared/Button';
import { signUpTenant } from '../../services/auth/authService';

const Register = () => {
    const [searchParams] = useSearchParams();
    const plan = searchParams.get('plan') || 'standard';
    const navigate = useNavigate();

    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        companyName: '',
        adminEmail: '',
        adminPassword: '',
        fullName: '',
        phone: '',
        taxNumber: '',
        taxOffice: '',
        country: 'Türkiye',
        city: '',
        district: '',
        address: ''
    });

    const handleNext = (e) => {
        e.preventDefault();
        setStep(2);
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const tenantData = {
                name: formData.companyName,
                plan: plan,
                phone: formData.phone,
                taxNumber: formData.taxNumber,
                taxOffice: formData.taxOffice,
                country: formData.country,
                city: formData.city,
                district: formData.district,
                address: formData.address
            };

            const userData = {
                fullName: formData.fullName,
                role: 'coordinator'
            };

            await signUpTenant(
                formData.adminEmail,
                formData.adminPassword,
                tenantData,
                userData
            );

            // Force reload to ensure App.js fetches the newly created user data
            window.location.href = '/';
        } catch (err) {
            setError(err.message || 'Kayıt sırasında bir hata oluştu.');
            console.error('Registration Error:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex justify-center items-center" style={{
            minHeight: '100vh',
            background: '#030303',
            padding: 'var(--spacing-md)',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Background Effects */}
            <div style={{
                position: 'absolute',
                top: '-10%',
                right: '-5%',
                width: '40%',
                height: '40%',
                background: 'radial-gradient(circle, rgba(55, 114, 255, 0.08) 0%, transparent 70%)',
                filter: 'blur(60px)',
                zIndex: 0
            }}></div>
            <div style={{
                position: 'absolute',
                bottom: '-10%',
                left: '-5%',
                width: '40%',
                height: '40%',
                background: 'radial-gradient(circle, rgba(55, 114, 255, 0.05) 0%, transparent 70%)',
                filter: 'blur(60px)',
                zIndex: 0
            }}></div>

            <div className="card-premium" style={{
                width: '100%',
                maxWidth: '600px',
                background: '#0c0c0c',
                border: '1px solid rgba(255, 255, 255, 0.05)',
                boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
                position: 'relative',
                zIndex: 1
            }}>
                <div className="text-center mb-xl">
                    <div style={{
                        display: 'inline-flex',
                        padding: '12px',
                        background: 'linear-gradient(135deg, #3772ff 0%, #0044ff 100%)',
                        borderRadius: '12px',
                        color: 'white',
                        marginBottom: 'var(--spacing-md)',
                        boxShadow: '0 8px 16px rgba(55, 114, 255, 0.2)'
                    }}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="8.5" cy="7" r="4"></circle>
                            <polyline points="17 11 19 13 23 9"></polyline>
                        </svg>
                    </div>
                    <h2 style={{ color: 'white', letterSpacing: '-0.5px' }}>Yeni Üyelik Oluştur</h2>
                    <p style={{ color: 'rgba(255,255,255,0.5)' }}>Seçilen Paket: <span style={{ color: '#3772ff', fontWeight: 'bold', textTransform: 'capitalize' }}>{plan}</span></p>
                </div>

                <div className="flex gap-xs mb-xl" style={{ opacity: 0.6 }}>
                    <div style={{ flex: 1, height: '3px', background: '#3772ff', borderRadius: '2px', boxShadow: '0 0 10px rgba(55,114,255,0.5)' }}></div>
                    <div style={{ flex: 1, height: '3px', background: step === 2 ? '#3772ff' : 'rgba(255,255,255,0.1)', borderRadius: '2px', transition: 'all 0.3s' }}></div>
                </div>

                {error && (
                    <div style={{
                        padding: '12px',
                        background: 'rgba(255, 50, 50, 0.1)',
                        border: '1px solid rgba(255, 50, 50, 0.2)',
                        borderRadius: '8px',
                        color: '#ff5555',
                        marginBottom: '20px',
                        fontSize: '14px',
                        textAlign: 'center'
                    }}>
                        {error}
                    </div>
                )}

                <form onSubmit={step === 1 ? handleNext : handleRegister}>
                    {step === 1 ? (
                        <div>
                            <div className="form-group">
                                <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)' }}>Şirket / Tesis Adı</label>
                                <input
                                    type="text"
                                    className="input"
                                    placeholder="Örn: ABC Lojistik A.Ş."
                                    required
                                    style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}
                                    value={formData.companyName}
                                    onChange={e => setFormData({ ...formData, companyName: e.target.value })}
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)' }}>Ad Soyad</label>
                                <input
                                    type="text"
                                    className="input"
                                    placeholder="John Doe"
                                    required
                                    style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}
                                    value={formData.fullName}
                                    onChange={e => setFormData({ ...formData, fullName: e.target.value })}
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)' }}>Yönetici E-posta</label>
                                <input
                                    type="email"
                                    className="input"
                                    placeholder="admin@sirketiniz.com"
                                    required
                                    style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}
                                    value={formData.adminEmail}
                                    onChange={e => setFormData({ ...formData, adminEmail: e.target.value })}
                                />
                            </div>
                            <div className="form-group">
                                <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)' }}>Şifre Belirleyin</label>
                                <input
                                    type="password"
                                    className="input"
                                    placeholder="••••••••"
                                    required
                                    style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}
                                    value={formData.adminPassword}
                                    onChange={e => setFormData({ ...formData, adminPassword: e.target.value })}
                                />
                            </div>
                            <Button type="submit" variant="primary" style={{ width: '100%', marginTop: 'var(--spacing-md)' }}>
                                Sonraki Adım
                            </Button>
                        </div>
                    ) : (
                        <div className="flex flex-col gap-md">
                            <div className="form-group">
                                <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)' }}>İletişim Telefonu</label>
                                <input
                                    type="tel"
                                    className="input"
                                    placeholder="+90 5XX XXX XX XX"
                                    required
                                    style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}
                                    value={formData.phone}
                                    onChange={e => setFormData({ ...formData, phone: e.target.value })}
                                />
                            </div>

                            {/* Billing Info Grid */}
                            <div className="grid grid-cols-2 gap-md">
                                <div className="form-group">
                                    <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)' }}>Vergi Numarası</label>
                                    <input
                                        type="text"
                                        className="input"
                                        placeholder="1234567890"
                                        required
                                        style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}
                                        value={formData.taxNumber}
                                        onChange={e => setFormData({ ...formData, taxNumber: e.target.value })}
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)' }}>Vergi Dairesi</label>
                                    <input
                                        type="text"
                                        className="input"
                                        placeholder="Vergi Dairesi"
                                        required
                                        style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}
                                        value={formData.taxOffice}
                                        onChange={e => setFormData({ ...formData, taxOffice: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-md">
                                <div className="form-group">
                                    <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)' }}>Ülke</label>
                                    <input
                                        type="text"
                                        className="input"
                                        placeholder="Türkiye"
                                        required
                                        style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}
                                        value={formData.country}
                                        onChange={e => setFormData({ ...formData, country: e.target.value })}
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)' }}>Şehir</label>
                                    <input
                                        type="text"
                                        className="input"
                                        placeholder="İstanbul"
                                        required
                                        style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}
                                        value={formData.city}
                                        onChange={e => setFormData({ ...formData, city: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)' }}>İlçe</label>
                                <input
                                    type="text"
                                    className="input"
                                    placeholder="Kadıköy"
                                    required
                                    style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}
                                    value={formData.district}
                                    onChange={e => setFormData({ ...formData, district: e.target.value })}
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label" style={{ color: 'rgba(255,255,255,0.7)' }}>Açık Adres</label>
                                <textarea
                                    className="textarea"
                                    placeholder="Cadde, sokak, no..."
                                    required
                                    style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', color: 'white', minHeight: '80px' }}
                                    value={formData.address}
                                    onChange={e => setFormData({ ...formData, address: e.target.value })}
                                ></textarea>
                            </div>

                            <div className="flex gap-md mt-lg">
                                <Button variant="secondary" onClick={() => setStep(1)} type="button" style={{ flex: 1, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}>Geri</Button>
                                <Button variant="primary" type="submit" loading={loading} style={{ flex: 2 }}>Kaydı Tamamla</Button>
                            </div>
                        </div>
                    )}
                </form>

                <div className="mt-xl text-center">
                    <button
                        onClick={() => navigate('/pricing')}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: 'rgba(255,255,255,0.4)',
                            fontSize: '13px',
                            cursor: 'pointer',
                            textDecoration: 'underline'
                        }}
                    >
                        Vazgeç ve Paketlere Dön
                    </button>
                </div>
            </div>

            {/* Footer Line */}
            <div style={{
                position: 'fixed',
                bottom: '20px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '100px',
                height: '2px',
                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                zIndex: 1
            }}></div>
        </div>
    );
};

export default Register;
